import React from 'react';
import { Item, MultiToggle } from '../../../../../core/components/toggle';
import simulatorConfig from '../../../constants/simulator-config-constants';
import { ExperimentConfiguration } from '../../../models';
import { ModalSectionContainer } from '../modal-section-container';

export interface NoiseStrengthSectionProps {
  config: ExperimentConfiguration[];
  setNoiseStrength: (action: string, value: string, configurationName: string) => void;
}

export const NoiseStrengthSection: React.FC<NoiseStrengthSectionProps> = (
  props: NoiseStrengthSectionProps
): React.ReactElement => {
  const { config, setNoiseStrength } = props;

  const onNoiseStrengthSelectHandler = (NoiseStrengthValue: string, NoiseStrengthName?: string) => {
    if (NoiseStrengthName) setNoiseStrength('true', NoiseStrengthValue, NoiseStrengthName);
  };

  const noiseStrength = config?.find((c: ExperimentConfiguration) => c.name === simulatorConfig.NOISE);

  type NoiseStrengthOptions = '0' | '1' | '2' | '3';

  const NOISE_STRENGTH_OPTIONS: Item<NoiseStrengthOptions>[] = [
    {
      id: '0',
      label: 'Off',
    },
    {
      id: '1',
      label: 'Low',
    },
    {
      id: '2',
      label: 'Medium',
    },
    {
      id: '3',
      label: 'High',
    },
  ];

  return (
    <ModalSectionContainer title="Noise" inBeta={noiseStrength?.inBeta}>
      <MultiToggle
        items={NOISE_STRENGTH_OPTIONS}
        onSelect={(key) => onNoiseStrengthSelectHandler(key as NoiseStrengthOptions, noiseStrength?.name)}
        selectedItemKey={noiseStrength?.selectedValue}
      />
    </ModalSectionContainer>
  );
};
